<template>
    <div>
        <form method="POST" action="/admin/statistics/sales/excel">
            <input type="hidden" name="_token" value="" id="form_token">
            <div class="row">
                <div class="col-md-9">
                    <h3>Выборка даты</h3>
                    <date-time-picker></date-time-picker>
                </div>
                <div class="col-md-3">
                    <div class="form-group">
                        <button type="button" class="btn btn-primary form-control" @click="load">
                            <span v-show="!show_loader">Выгрузить данные</span>
                            <i v-show="show_loader" class="fa fa-spinner fa-spin" style="font-size:24px"></i>
                        </button>
                    </div>
                    <div class="form-group" v-if="date_start.length && date_finish.length">
                        <button type="submit" class="btn btn-success form-control">
                            <i class="fa fa-file-excel-o"></i>
                            Сохранить в Excel
                        </button>
                    </div>
                    <div class="form-group">
                        <input v-for="column in columns" type="hidden"
                               :name="`columns[${column.title}]`"
                               :value="column.code"
                        >
                        <input type="hidden" name="dates[]" :value="date_start">
                        <input type="hidden" name="dates[]" :value="date_finish">
                    </div>
                </div>
            </div>
        </form>
        <div class="row" v-if="sellers_data.length > 0">
            <div class="col-md-12">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th>№</th>
                            <th v-for="column in columns" v-text="column.title"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(data, key) in sellers_data">
                            <td><b>{{ key + 1 }}.</b></td>
                            <td v-for="column in columns" v-text="data[column.code]"></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="row" v-if="sales_data.length > 0">
            <div class="col-md-12">
                <div class="panel panel-primary">
                    <div class="panel-heading">Заказы без продавцов</div>
                    <div class="panel-body">
                        <table class="table table-striped">
                            <thead>
                            <tr>
                                <th>№</th>
                                <th v-for="column in columns" v-text="column.title"></th>
                            </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(data, key) in sales_data">
                                    <td><b>{{ key + 1 }}.</b></td>
                                    <td v-for="column in columns" v-text="data[column.code]"></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    created: function () {
        this.$root.$on('update:date_time_range', (val) => {
            this.date_start = val.date_time_start;
            this.date_finish = val.date_time_finish;
        });
    },
    mounted: function() {
        Vue.http.headers.common['X-CSRF-TOKEN'] = document.querySelector('#token').getAttribute('content');
        document.querySelector('#form_token').value = document.querySelector('#token').getAttribute('content');
    },
    data: function () {
        let columns = [
            { code: 'email', title: 'Email адрес' },
            { code: 'orders_sum', title: 'Сумма заказов' },
            { code: 'orders_count', title: 'Кол-во заказов' },
            { code: 'avg_price', title: 'Средняя цена заказа' },
            { code: 'variants_count', title: 'Кол-во упаковок в заказах' },
            { code: 'order_profit', title: 'Профит' },
            { code: 'order_margin', title: 'Маржа (%)' }
        ];

        return {
            date_start: '',
            date_finish: '',
            sales_data: [],
            sellers_data: [],
            columns: columns,
            show_loader: false,
        };
    },
    methods: {
        // LOADING DATA
        checkEnteredData: function () {
            return this.date_start && this.date_finish;
        },
        load: function () {
            if (!this.checkEnteredData()) {
                alert('Заполните обязательные поля!');
                return;
            }
            this.show_loader = true;

            this.$http.post('/statistics/sales/get', {
                columns: this.getCodes(this.columns),
                dates: [this.date_start, this.date_finish],
            }).then(function (response) {
                this.show_loader = false;
                this.sales_data = response.data.sales_data;
                this.sellers_data = response.data.sellers_data;
            }, function (response) {
                this.displayErrors(response);
            });
        },
        getCodes: function (arr) {
            let codes = [];

            arr.forEach(function (item) {
                codes.push(item.code);
            });

            return codes;
        },
        displayErrors: function (response) {
            let errors = '';
            this.show_loader = false;

            for (let field in response.data) {
                errors += response.data[field] + '\r\n';
            }

            alert(errors);
        },
    },
};
</script>
